const dialog = require('../../../../../components/dialog/dialog')
const dtHandler = require('../../../../../components/dt/dt-handler')

const invalidCheckColumns = [
	{ key: 'code', label: 'Sent Payment', behavior: false, displayText: true },
	{ key: 'provider_name', label: 'Provider', behavior: false, displayText: true },
	{ key: 'accounts_name', label: 'From Account', behavior: false, displayText: true },
]

function escapeDialogText(value) {
	return String(value ?? '')
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#039;')
}

function invalidCheckRows(payments) {
	return payments.map((payment) => ({
		code: escapeDialogText(payment.code || `ID ${payment.id}`),
		provider_name: escapeDialogText(payment.provider_name),
		accounts_name: escapeDialogText(payment.accounts_name),
	}))
}

export function start(detail) {

	dialogBody[detail.id].start(detail)

	detail.html = dialogBody[detail.id]
	dialog.start(detail)
}

const dialogBody = {

	checksPrintedConfirmation: {
		title: '',
		des: '',
		bodyHtml: '',

		primary: {
			text: 'Mark as Printed',
			class: 'button primary',
			dataDetail: '',
		},

		secondary: {
			text: 'Not Now',
			class: 'button secondary button-plain',
			dataDetail: '',
		},

		tertiary: {
			text: '',
			class: '',
			dataDetail: '',
		},

		start: function(detail) {
			const ids = Array.isArray(detail.ids) ? detail.ids : []


			this.title = `Were the checks printed successfully?`
			this.des = `If all checks were printed successfully, you can mark them all as printed.`
			this.primary.dataDetail = `data-detail='{
				"click": [
					{"dest":"ripple"},
					{"dest":"dialog", "act":"hide"},
					{"dest":"sentpayment", "elem":"quickform", "act":"markPrinted", "ids":${JSON.stringify(ids)}}
				]}'`
			this.secondary.dataDetail = `data-detail='{
				"click": [
					{"dest":"ripple"},
					{"dest":"dialog", "act":"hide"},
					{"dest":"sentpayment", "elem":"quickform", "act":"finishWithoutMark"}
				]}'`
		},
	},

	checkStatusUpdateError: {
		title: '',
		des: '',
		bodyHtml: '',

		primary: {
			text: 'Close',
			class: 'button primary',
			dataDetail: '',
		},

		secondary: { text: '', class: '', dataDetail: '' },
		tertiary: { text: '', class: '', dataDetail: '' },

		start: function() {
			this.title = 'Unable to update the check status'
			this.des = 'The checks were generated, but their status could not be changed to Printed. Please try again.'
			this.primary.dataDetail = `data-detail='{
				"click": [ {"dest":"ripple"}, {"dest":"dialog", "act":"hide"} ]}'`
		},
	},

	checkPaymentNotFound: {
		title: '',
		des: '',
		bodyHtml: '',

		primary: {
			text: 'Close',
			class: 'button primary',
			dataDetail: '',
		},

		secondary: {
			text: '',
			class: '',
			dataDetail: '',
		},

		tertiary: {
			text: '',
			class: '',
			dataDetail: '',
		},

		start: function(detail) {
			this.title = 'Sent payment not found'
			this.des = 'The selected Sent Payment is no longer available. Refresh the list and try again.'
			this.primary.dataDetail = `data-detail='{
				"click": [ {"dest":"ripple"}, {"dest":"dialog", "act":"hide"} ]}'`
		},
	},

	checkGenerationDisabled: {
		title: '',
		des: '',
		bodyHtml: '',

		primary: {
			text: 'Close',
			class: 'button primary',
			dataDetail: '',
		},

		secondary: {
			text: '',
			class: '',
			dataDetail: '',
		},

		tertiary: {
			text: '',
			class: '',
			dataDetail: '',
		},

		start: function(detail) {
			const payments = Array.isArray(detail.payments) ? detail.payments : []
			const selectedCount = Number(detail.selectedCount) || payments.length

			if (payments.length > 0 && selectedCount > 1) {
				const paymentWord = payments.length === 1 ? 'payment' : 'payments'
				const verb = payments.length === 1 ? 'is' : 'are'

				this.title = payments.length === 1
					? 'A selected payment cannot be printed as a check'
					: 'Some selected payments cannot be printed as checks'
				this.des = `Check Generation is not enabled for ${payments.length} of the ${selectedCount} selected payments. The invalid ${paymentWord} ${verb} listed below. Enable Check Generation or remove the listed ${paymentWord} from the selection, then try again.`
				// Muestra cada pago no valido con el componente DT Simple del framework.
				this.bodyHtml = dtHandler.dtSimpleFc(invalidCheckRows(payments), invalidCheckColumns)
			} else {
				this.title = 'Check generation is not enabled'
				this.des = 'Enable Check Generation for this Sent Payment before printing the check.'
				this.bodyHtml = ''
			}
			this.primary.dataDetail = `data-detail='{
				"click": [ {"dest":"ripple"}, {"dest":"dialog", "act":"hide"} ]}'`
		},
	},

	checkBankInformationDisabled: {
		title: '',
		des: '',
		bodyHtml: '',

		primary: {
			text: 'Close',
			class: 'button primary',
			dataDetail: '',
		},

		secondary: {
			text: '',
			class: '',
			dataDetail: '',
		},

		tertiary: {
			text: '',
			class: '',
			dataDetail: '',
		},

		start: function(detail) {
			this.title = 'Bank information is not enabled'
			this.des = 'Enable Bank Information for the selected From Account before printing this check.'
			this.primary.dataDetail = `data-detail='{
				"click": [ {"dest":"ripple"}, {"dest":"dialog", "act":"hide"} ]}'`
		},
	},

	checkAccountNumberMissing: {
		title: '',
		des: '',
		bodyHtml: '',

		primary: {
			text: 'Close',
			class: 'button primary',
			dataDetail: '',
		},

		secondary: {
			text: '',
			class: '',
			dataDetail: '',
		},

		tertiary: {
			text: '',
			class: '',
			dataDetail: '',
		},

		start: function(detail) {
			this.title = 'Account number is missing'
			this.des = 'Add an Account Number to the selected From Account before printing this check.'
			this.primary.dataDetail = `data-detail='{
				"click": [ {"dest":"ripple"}, {"dest":"dialog", "act":"hide"} ]}'`
		},
	},

	checkRoutingNumberInvalid: {
		title: '',
		des: '',
		bodyHtml: '',

		primary: {
			text: 'Close',
			class: 'button primary',
			dataDetail: '',
		},

		secondary: {
			text: '',
			class: '',
			dataDetail: '',
		},

		tertiary: {
			text: '',
			class: '',
			dataDetail: '',
		},

		start: function(detail) {
			this.title = 'Routing number is invalid'
			this.des = 'Add a valid 9-digit ABA Routing Number to the selected From Account before printing this check.'
			this.primary.dataDetail = `data-detail='{
				"click": [ {"dest":"ripple"}, {"dest":"dialog", "act":"hide"} ]}'`
		},
	},

	missingDefaultCheckSignature: {
		title: '',
		des: '',
		bodyHtml: '',

		primary: {
			text: 'Close',
			class: 'button primary',
			dataDetail: '',
		},

		secondary: {
			text: '',
			class: '',
			dataDetail: '',
		},

		tertiary: {
			text: '',
			class: '',
			dataDetail: '',
		},

		start: function(detail) {
			this.title = 'Default check signature is missing'
			this.des = 'Checks are configured to use a default signature, but no signature has been saved. Add the signature in Company settings before printing this check.'
			this.primary.dataDetail = `data-detail='{
				"click": [ {"dest":"ripple"}, {"dest":"dialog", "act":"hide"} ]}'`
		},
	},

	checkPrintError: {
		title: '',
		des: '',
		bodyHtml: '',

		primary: {
			text: 'Close',
			class: 'button primary',
			dataDetail: '',
		},

		secondary: {
			text: '',
			class: '',
			dataDetail: '',
		},

		tertiary: {
			text: '',
			class: '',
			dataDetail: '',
		},

		start: function(detail) {
			this.title = 'Unable to print the check'
			this.des = 'The check could not be generated. Verify the Sent Payment and its From Account, then try again.'
			this.primary.dataDetail = `data-detail='{
				"click": [ {"dest":"ripple"}, {"dest":"dialog", "act":"hide"} ]}'`
		},
	},

	hellow: {
		title: '',
		des: '',
		bodyHtml: `

				<div class="textfield textfield-filled  textfield-autocomplete" id="_______">

				  <input class='elem' type="text" value="empy1"
				         data-detail='{"key": [{"dest":"textfield", "act":"typing"}]}' >

				  <div class="indicador"></div>

				  <div class="trailing" data-detail='{"click": [{"dest":"textfield", "act":"clear"}]}' >
				    <svg><use xlink:href="../../../public/css/svg.svg#cancel"></use></svg>
				  </div>

				  <div class="label">text</div>
				  <div class="helper">Required*</div>
				  <div class="counter">10/10</div>
				  <div class="selector"></div>
				</div><!-- textfield -->

				<div class="textfield textfield-filled  textfield-autocomplete" id="_______">

				  <input class='elem' type="text" value="empy1"
				         data-detail='{"key": [{"dest":"textfield", "act":"typing"}]}' >

				  <div class="indicador"></div>

				  <div class="trailing" data-detail='{"click": [{"dest":"textfield", "act":"clear"}]}' >
				    <svg><use xlink:href="../../../public/css/svg.svg#cancel"></use></svg>
				  </div>

				  <div class="label">text</div>
				  <div class="helper">Required*</div>
				  <div class="counter">10/10</div>
				  <div class="selector"></div>
				</div><!-- textfield -->
		`,

		primary: {
			text: '',
			class: 'button primary',
			dataDetail: '',
		},

		secondary: {
			text: '',
			class: 'button secondary button-plain',
			dataDetail: '',
		},

		tertiary: {
			text: '',
			class: 'button secondary button-plain',
			dataDetail: '',
		},

		start: function(detail) {
			this.title = 'TEST title'
			this.des = ''
			this.primary.text = 'TEST 111'
			this.secondary.text = 'TEST 222'
			this.tertiary.text = 'TEST 33333'
			this.primary.dataDetail = `data-detail='{
				"click": [ {"dest":"ripple"}, {"dest":"dialog", "act":"hide"} ]}'`
			this.secondary.dataDetail = `data-detail='{
				"click": [ {"dest":"ripple"}, {"dest":"dialog", "act":"hide"} ]}'`
			this.tertiary.dataDetail = `data-detail='{
				"click": [ {"dest":"ripple"}, {"dest":"dialog", "act":"hide"} ]}'`
		},
	},
}
